<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form layout="inline">
        <a-form-item>
          <a-input
            placeholder="商户名称"
            v-model:value="searchForm.name"
            allowClear
            @keyup.enter.native="searchAction()"
          />
        </a-form-item>
        <a-form-item>
          <a-select
            v-model:value="searchForm.state"
            placeholder="商户类型"
            style="width: 192px"
            @change="searchAction"
          >
            <a-select-option
              v-for="(item, index) in stateList"
              :key="index"
              :value="item.val"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item>
          <a-range-picker
            v-model:value="searchForm.date"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
          />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="searchAction"> 查询 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
        <a-form-item> </a-form-item>
      </a-form>
    </a-card>

    <a-card
      size="small"
      title="商户列表"
      style="margin-top: 20px"
      :headStyle="{
        background: '#f3f3f3',
      }"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <template v-slot:extra>
        <a-button @click="toAdd" type="primary">添加</a-button>
      </template>
    </a-card>
    <a-table
      style="overflow: auto"
      :columns="columns"
      bordered
      :data-source="list"
      :pagination="false"
      :row-key="(r) => r.id"
      :loading="loading"
    >
      <template v-slot:name="{ text, record, index }">
        <span style="color: #464c5b; cursor: pointer" @click="toLook(record)">{{
          record.name
        }}</span>
      </template>

      <template v-slot:logo="{ text, record, index }">
        <img :src="baseuri + record.logo" class="table_logo" />
      </template>
      <template v-slot:policy="{ text, record, index }">
        <a
          :href="
            '/train-admin/channelShop/policy-ticket?distributorId=' + record.id
          "
          >差标管理</a
        >
      </template>
      <template v-slot:businessModules="{ text, record, index }">
        <a-tag
          color="green"
          style="margin-top: 3px; margin-right: 3px"
          v-for="(item, index) in record.businessModules.split(',')"
          :key="index"
        >
          {{ staticof.business[item] }}
        </a-tag>
      </template>
      <template v-slot:buyModelValues="{ text, record, index }">
        <a-tag
            color="green"
            style="margin-top: 3px; margin-right: 3px"
            v-for="(item, index) in record.buyModelValues.split(',')"
            :key="index"
        >
          {{ item }}
        </a-tag>
      </template>
      <template v-slot:state="{ text, record, index }">
        <a-switch
          checked-children="开"
          un-checked-children="关"
          :checked="record.open"
          @click="changeBtn(record)"
        />
      </template>

      <template v-slot:createTime="{ text, record, index }">
        {{ record.createTime }}
      </template>

      <template v-slot:operation="{ text, record, index }">
        <a-button type="primary" @click="toEdit(record)"> 编辑 </a-button>

        <a-button @click="seeAccount(record)" style="margin-left: 10px">
          查看账号
        </a-button>
      </template>
    </a-table>

    <df-pagination :model="pageObj"></df-pagination>
  </div>
</template>

<script>
import shopApi from "@axios/shop";
import staticof from "@assets/static";
import { ref, reactive, provide } from "vue";
import { useRoute, useRouter } from "vue-router";
import { notification } from "ant-design-vue";
import { SmileOutlined } from "@ant-design/icons-vue";

export default {
  name: "shop",
  components: {},
  setup() {
    const router = useRouter();

    let loading = ref(false);
    let searchForm = reactive({
      name: "",
      state: 999,
      date: [],
    });
    let searchParams = reactive({
      name: "",
      state: 999,
      date: [],
    });

    let names = ref("");

    const stateList = [
      {
        name: "全部",
        val: 999,
      },
      {
        name: "开启",
        val: 10,
      },
      {
        name: "关闭",
        val: 20,
      },
    ];

    let list = ref([]);

    const columns = [
      {
        title: "商户名称",
        dataIndex: "name",
        width: 200,
        align: "left",
        slots: { customRender: "name" },
      },
      {
        title: "logo",
        dataIndex: "name",
        width: 200,
        align: "center",
        slots: { customRender: "logo" },
      },
      {
        title: "差标",
        dataIndex: "policy",
        width: 200,
        align: "center",
        slots: { customRender: "policy" },
      },
      {
        title: "分销域名",
        dataIndex: "region",
        width: 200,
        align: "center",
      },

      {
        title: "开通业务",
        dataIndex: "businessModules",
        width: 100,
        align: "center",
        slots: { customRender: "businessModules" },
      },
      {
        title: "创建时间",
        dataIndex: "createTime",
        width: 100,
        align: "center",
        slots: { customRender: "createTime" },
      },
      {
        title: "商户状态",
        dataIndex: "state",
        width: 50,
        align: "center",
        slots: { customRender: "state" },
      },
      {
        title: "操作",
        align: "center",
        dataIndex: "operation",
        key: "operation",
        width: 250,
        slots: { customRender: "operation" },
      },
    ];

    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    const stateValue = ["关闭", "开启"];

    const searchAction = () => {
      searchParams.name = searchForm.name;
      searchParams.state = searchForm.state;
      searchParams.date = searchForm.date;
      console.log(searchParams);
      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };

    const getList = () => {
      loading.value = true;
      let params = {
        name: searchParams.name ? searchParams.name : null,
        createBeginTime: searchParams.date[0] ? searchParams.date[0] : null,
        createEndTime: searchParams.date[1] ? searchParams.date[1] : null,
        // state : searchParams.state == 10?1:0,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };

      if (searchParams.state === 10) {
        params.state = 1;
      } else if (searchParams.state === 20) {
        params.state = 0;
      }

      shopApi.getDistributorList(params).then((res) => {
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.currentPage;
        res.data.forEach((element) => {
          element.open = element.state == 1 ? true : false;
        });
        list.value = res.data;
      });

      shopApi.getSupplierAll({"businessModules":"10"}).then((res) => {
        sessionStorage.setItem("SupplierAll",JSON.stringify(res))
      });
    };

    const reset = () => {
      searchForm.name = "";
      searchForm.state = 999;
      searchForm.date = [];
      searchAction();
    };
    const toLook = (row) => {
      router.push({
        name: "addChannelShopIndex",
        query: {
          id: row.id,
          type: "look",
        },
      });
    };

    const toAdd = () => {
      router.push({
        name: "addChannelShopIndex",
      });
    };
    const toEdit = (row) => {
      router.push({
        name: "addChannelShopIndex",
        query: {
          id: row.id,
          type: "edit",
        },
      });
    };
    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    const changeBtn = (row) => {
      let params = {
        lid: row.id,
        type: row.state == 1 ? 0 : 1,
      };
      shopApi.switchDistributor(params).then(() => {
        searchAction();

        notification.open({
          message: "修改成功",
          icon: <SmileOutlined style="color: #108ee9" />,
        });
      });
    };

    const seeAccount = (row) => {
      const newweb = router.resolve({
        name: "channelAccountIndex",
        query: {
          distributorId: row.id,
        },
      });
      window.open(newweb.href, "_blank");
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);

    getList();

    return {
      seeAccount,
      changeBtn,
      names,
      // data
      staticof,
      loading,
      searchForm,
      searchParams,
      stateList,
      list,
      columns,
      pageObj,
      stateValue,
      //methods
      searchAction,
      reset,
      toLook,
      toAdd,
      toEdit,
      baseuri: process.env.VUE_APP_IMG_BASE,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.table_logo {
  width: 80px;
}
</style>



